export default __webpack_public_path__ + "static/usatodaylogo-15fea3b260f6cfd75bef584f90a51cfe.svg";